__turbopack_context__.v({
  "comboVariantGroup": "iTQB3q_comboVariantGroup",
  "modalDescription": "iTQB3q_modalDescription",
  "modalResults": "iTQB3q_modalResults",
  "modalSection": "iTQB3q_modalSection",
  "modalTitle": "iTQB3q_modalTitle",
  "more": "iTQB3q_more",
  "mostPopular": "iTQB3q_mostPopular",
  "muted": "iTQB3q_muted",
  "piece": "iTQB3q_piece",
  "replacement": "iTQB3q_replacement",
  "replacements": "iTQB3q_replacements",
  "stop": "iTQB3q_stop",
  "tree": "iTQB3q_tree",
});
